import React from "react";
import BaseIcon from "../../../../../components/svg_icons/BaseIcon";

const departments = [
    {
        name: "GST",
        employees: 42,
        activeTasks: 18,
        pendingTasks: 5,
        completion: 91,
        color: "#2563eb",
    },
    {
        name: "Audit",
        employees: 31,
        activeTasks: 12,
        pendingTasks: 3,
        completion: 84,
        color: "#10b981",
    },
    {
        name: "Income Tax",
        employees: 28,
        activeTasks: 14,
        pendingTasks: 6,
        completion: 88,
        color: "#8b5cf6",
    },
    {
        name: "Payroll",
        employees: 15,
        activeTasks: 7,
        pendingTasks: 2,
        completion: 95,
        color: "#f59e0b",
    },
];

const DepartmentOverview = () => {
    return (
        <div
            style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "16px",
                padding: "24px",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "24px",
                }}
            >
                <div>
                    <h2
                        style={{
                            margin: 0,
                            color: "#0f172a",
                        }}
                    >
                        Departments
                    </h2>

                    <p
                        style={{
                            marginTop: "6px",
                            color: "#64748b",
                            fontSize: "14px",
                        }}
                    >
                        Department-wise operational overview.
                    </p>
                </div>

                <button
                    style={{
                        padding: "8px 14px",
                        border: "1px solid #d1d5db",
                        borderRadius: "10px",
                        background: "#fff",
                        cursor: "pointer",
                    }}
                >
                    View All
                </button>
            </div>

            {departments.map((dept) => (
                <div
                    key={dept.name}
                    style={{
                        border: "1px solid #e5e7eb",
                        borderLeft: `5px solid ${dept.color}`,
                        borderRadius: "12px",
                        padding: "18px",
                        marginBottom: "16px",
                        transition: "0.2s",
                        cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = "#f8fafc";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = "#fff";
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "14px",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                            }}
                        >
                            <div
                                style={{
                                    width: "42px",
                                    height: "42px",
                                    borderRadius: "10px",
                                    background: `${dept.color}20`,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: dept.color,
                                }}
                            >
                                <BaseIcon name="briefcase" />
                            </div>

                            <div>
                                <strong>{dept.name}</strong>

                                <div
                                    style={{
                                        fontSize: "13px",
                                        color: "#64748b",
                                    }}
                                >
                                    {dept.employees} Employees
                                </div>
                            </div>
                        </div>

                        <strong style={{ color: dept.color }}>
                            {dept.completion}%
                        </strong>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: "14px",
                            color: "#475569",
                            marginBottom: "10px",
                        }}
                    >
                        <span>Active Tasks: {dept.activeTasks}</span>

                        <span>Pending: {dept.pendingTasks}</span>
                    </div>

                    <div
                        style={{
                            height: "8px",
                            background: "#e5e7eb",
                            borderRadius: "999px",
                            overflow: "hidden",
                        }}
                    >
                        <div
                            style={{
                                width: `${dept.completion}%`,
                                height: "100%",
                                background: dept.color,
                            }}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default DepartmentOverview;
